import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/prouser/clientes/v1`;

const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export function findCliente({
  empresa_cnpj,
  id,
  include,
  where = {},
  orwhere = {},
  page,
  perPage,
  fields,
  trashedInclude,
}) {
  let queryWhere = "";
  Object.keys(where).forEach((key) => {
    queryWhere += `&where[${key}]=${where[key]}`;
  });

  let queryOrWhere = "";
  Object.keys(orwhere).forEach((key) => {
    queryOrWhere += `&orwhere[${key}]=${orwhere[key]}`;
  });

  return search(
    `${path}${
      id ? `/${id}` : ""
    }?empresa_cnpj=${empresa_cnpj}${queryWhere}${queryOrWhere}${
      include ? `&include=${include}` : ""
    }${trashedInclude ? `&trashedInclude=${trashedInclude}` : ""}${
      page ? `&page=${page}` : ""
    }${perPage ? `&per_page=${perPage}` : ""}${
      fields ? `&fields[prouser.clientes]=${fields}` : ""
    }`,
    "GET",
    headers
  );
}

export async function findClienteByCpfCnpj(empresa_cnpj, cpfcnpj) {
  return search(
    `${path}?empresa_cnpj=${empresa_cnpj}&where[cpfcnpj]=${cpfcnpj}`,
    "GET",
    headers
  );
}

export async function consultOverdueBills({ empresa_cnpj, clientId }) {
  return search(
    `${path}/check-conta-atraso?empresa_cnpj=${empresa_cnpj}&idcliente=${clientId}`,
    "GET",
    headers
  );
}

export async function consultCreditLimit({ empresa_cnpj, clientId }) {
  return search(
    `${path}/consulta-limite-credito?empresa_cnpj=${empresa_cnpj}&idcliente=${clientId}`,
    "GET",
    headers
  );
}

export function createCliente(empresa_cnpj, body, include = "") {
  return search(
    `${path}?empresa_cnpj=${empresa_cnpj}${
      include ? `&include=${include}` : ""
    }`,
    "POST",
    headers,
    body
  );
}

export async function updateCliente(id, empresa_cnpj, body) {
  return search(
    `${path}/${id}?empresa_cnpj=${empresa_cnpj}`,
    "PUT",
    headers,
    body
  );
}

export function deleteCliente(id, empresa_cnpj) {
  return search(
    `${path}/${id}?empresa_cnpj=${empresa_cnpj}`,
    "DELETE",
    headers
  );
}

export async function clientFilterSales(
  empresa_cnpj,
  empresa_id,
  { onlyOpenedSales, origin, startDate, finalDate, orWhere = {} }
) {
  let queryOrWhere = "";
  Object.keys(orWhere).forEach((key) => {
    queryOrWhere += `&orwhere[${key}]=${orWhere[key]}`;
  });

  return search(
    `${path}/filtrovendas?empresa_cnpj=${empresa_cnpj}&empresa_id=${empresa_id}&onlyOpenedSales=${onlyOpenedSales}&origin=${origin}&startDate=${startDate}&finalDate=${finalDate}${queryOrWhere}&per_page=100`,
    "GET",
    headers
  );
}
